import React, {Component} from "react";
import {Row, Col, Card, Button} from "react-materialize";
import tools from "../../images/tools.png";
import {Link} from 'react-router-dom';

import What_if_do from './what_if_do';
import {injectIntl, intlShape} from 'react-intl';

import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

class What_if extends Component {



    render() {



        return (


            <Card>
                <Row className={"valign-wrapper"}>
                    <Col s={2} m={2}>

                        <div align="center">
                            <img src={tools} className={"img"} alt={"tools image"}/>
                        </div>
                    </Col>

                    <Col s={10} m={10}>
                        <h5><p><b><FormattedMessage id={"tools.header"} defaultMessage={"Ferramentas"}/></b></p></h5>
                    </Col>
                </Row>

                <Row>
                    <Col s={2} m={2}>
                        {/*Alocando espaço*/}
                    </Col>

                    <Col s={10} m={10}>
                        <div align="justify">
                            <p><b>What if? </b></p>
                            <p><FormattedMessage id={"what.if.text"} defaultMessage={"What if? (E se?) é uma técnica simples para identificar e prevenir riscos. Consiste em avaliar o fluxo do processo, necessitando ser realizado por pessoas que conheçam bem a atividade. Para cada atividade a ser avaliada, questiona-se um evento adverso, podendo sugerir possíveis causas e consequências e medidas preventivas para evitar ou controlar o risco."}/></p>


                        </div>
                    </Col>
                </Row>

                <Row classname={"valign-wrapper"}>

                    <div align="center">
                        <Link to={"/what_if_do"}>
                        <Button className={"button"} >OK</Button></Link></div>
                </Row>

            </Card>
        )
    }
};

export default What_if;